// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"ea1ef9a2","118":"47ea2d76","305":"8984f75e","323":"6cb5a873","335":"06c23b06","395":"b82b00b4","453":"f6113c9e","564":"d89d711c","574":"7f352385","812":"1d20d842","843":"6e07422b","931":"fc3e8ee9"}[chunkId] + ".chunk.js";
};